import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Personal } from "./Personal";

export const ACTReemplazarPersonal: EntityClientAction = {
    name: 'ACTReemplazarPersonal',
    label: 'Reemplazar Personal',
    title: <Text fw={700}>Reemplazar Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    showActionInViewMode: true,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [''],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const personal = entity as Personal;

        const procParms = {
            c_personal_id: selectedKeys?.[0]?.['c_personal_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_personal_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        await modal.open({
            modalProps: {
                title: <Text fw="700">Reemplazar personal</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={personal}
                viewName={personal.def.views.perl_brwAsignarSuperior.name}
                title="Reemplazar personal seleccionado"
                confirmContent="¿Está seguro de que desea asignar el superior al personal seleccionado?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        const abort_controller = new AbortController();

                        if (selectedKeys && selectedKeys.length === 1) {
                            entity.def.columns.c_superior_id.value = keys![0].c_personal_id;
                            const result = await entity.API.executeProcess(entity.def.procs.perl_ReemplazarPersonal, procParms, abort_controller.signal, selectedKeys);

                            if (!result.Failed) {
                                if (onClose) await onClose();
                                await modal.close();
                            }
                        }
                        return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                    }
                }
            />

        });

        return false;
    }
}